import { Injectable } from '@angular/core';
import { Params } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class QueryParameterFormatterService {
  public formatQueryParams(queryParams?: Params): Params | undefined {
    if (!queryParams) {
      return undefined;
    }

    const returnValue: Params = {};

    for (const key of Object.keys(queryParams)) {
      const value: unknown = queryParams[key];

      if (value === undefined || value === null || value === '') {
        continue;
      }

      if (!Array.isArray(value)) {
        returnValue[key] = value;
      } else if (value.length) {
        returnValue[key] = (value as []).join(',');
      }
    }

    return returnValue;
  }
}
